import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppHeader from '../../components/AppHeader';
import { eventsApi } from '../../api';

export default function MuList() {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', location: '', event_date: '', description: '' });
  const [error, setError] = useState('');

  const load = () => eventsApi.list().then((r) => setEvents(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const date = form.event_date || new Date().toISOString().slice(0, 16);
      const res = await eventsApi.create({ ...form, event_date: date });
      navigate(`/mu/${res.data.id}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Vytvoření selhalo.');
    }
  };

  const fmtDate = (d) => d ? new Date(d).toLocaleDateString('cs-CZ') : '';

  return (
    <div>
      <AppHeader subtitle="Mimořádné události" />
      <div className="container-wide" style={{ paddingTop: 24 }}>
        <div className="flex" style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h2>Mimořádné události</h2>
          {!showForm && <button className="btn btn-primary btn-sm" onClick={() => setShowForm(true)}>+ Nová MU</button>}
        </div>

        {showForm && (
          <div className="card mb-16">
            <h3 className="mb-16">Nová mimořádná událost</h3>
            <form onSubmit={create}>
              <div className="form-group">
                <label>Název</label>
                <input className="form-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
              </div>
              <div className="flex gap-8">
                <div className="form-group flex-1">
                  <label>Místo</label>
                  <input className="form-input" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} />
                </div>
                <div className="form-group flex-1">
                  <label>Datum a čas</label>
                  <input type="datetime-local" className="form-input" value={form.event_date} onChange={(e) => setForm({ ...form, event_date: e.target.value })} />
                </div>
              </div>
              <div className="form-group">
                <label>Popis</label>
                <input className="form-input" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
              </div>
              {error && <div className="alert alert-warning mb-16">{error}</div>}
              <div className="flex gap-8">
                <button type="submit" className="btn btn-primary flex-1">Vytvořit</button>
                <button type="button" className="btn btn-outline" onClick={() => setShowForm(false)}>Zrušit</button>
              </div>
            </form>
          </div>
        )}

        <div className="table-wrapper">
          <table>
            <thead><tr><th>Název</th><th>Místo</th><th>Datum</th><th>Zóny</th><th>Přítomno</th><th>Stav</th></tr></thead>
            <tbody>
              {events.map((e) => (
                <tr key={e.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/mu/${e.id}`)}>
                  <td>{e.name}</td>
                  <td>{e.location || ''}</td>
                  <td>{fmtDate(e.event_date)}</td>
                  <td>{e.zone_count}</td>
                  <td>{e.active_count}</td>
                  <td>{e.active ? <span className="badge badge-in">aktivní</span> : <span className="badge badge-none">neaktivní</span>}</td>
                </tr>
              ))}
              {events.length === 0 && <tr><td colSpan={6} className="text-muted text-center">Žádné MU.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
